import {Component, Property} from '@wonderlandengine/api';

const tempVec = new Float32Array(3);

export class MoveForward extends Component {
    static TypeName = 'move-forward';
    static Properties = {
 	staplerObject: Property.object(),
        speed: Property.float(0.005),
    };

    update(dt) {
        this.staplerObject.getForward(tempVec);

        tempVec[0] *= this.speed;
        tempVec[1] *= this.speed;
        tempVec[2] *= this.speed;

        this.staplerObject.translate(tempVec);
    }
}